<wlm-placeholder-overlay
  *ngIf="!chartConfiguration"
  [titleKey]="phTitleKey"
  [subtitleKey]="phSubtitleKey"
></wlm-placeholder-overlay>

<ct-customizable-chart
  *ngIf="chartConfiguration"
  [chartConfiguration]="chartConfiguration"
  [containerSize$]="size$"
  (chartConfigurationChange)="onChartConfigurationChange($event)"
></ct-customizable-chart>
